import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { OnboardingRepo as OnboardingRepo } from "@services/onboarding.repo";
import { registeredClient } from "./registeredClient";

export const registeredClientModule = "clientView";

angular
  .module(registeredClientModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService"
  ])
  .constant("config", constants.Default)
  .service("onboardingRepo", OnboardingRepo)
  .component("registeredClient", registeredClient);




// WEBPACK FOOTER //
// ./src/app/onboarding/registeredClient/registeredclient.index.ts